module.exports = __webpack_public_path__ + "static/media/bag-full-grey.0a2374d7.png";